import useTranslation from "../../../client/hooks/useTranslation";
import { Card } from "../../ui/ui";

/**
 * Lien playbook -> analyse. Vrai dans le code : une analyse se lance sur UN
 * playbook (analyzeService), dont les comptes ciblés fixent le périmètre
 * (analysisScope) et dont les règles sont confrontées aux trades (analysisContext).
 */
export function HowItWorks() {
  const t = useTranslation().lite.edgy.how;
  return (
    <Card title={t.title}>
      <ol className="grid gap-3 md:grid-cols-3">
        {t.steps.map((step, i) => (
          <li key={i} className="flex gap-3 text-sm text-muted-foreground">
            <span className="w-6 h-6 shrink-0 rounded-full bg-primary/10 text-primary text-xs font-semibold grid place-items-center">{i + 1}</span>
            <span>{step}</span>
          </li>
        ))}
      </ol>
    </Card>
  );
}
